module.exports = __webpack_public_path__ + "img/03.021f8643.jpg";